import { ApolloClient } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { connect } from 'react-redux';
import { ReactNode } from 'react';

import clientSingleton from '../../cms/client';

type CustomApolloProviderProps = {
  children: ReactNode;
  client: ApolloClient;
};

const CustomApolloProvider = ({ client, children }: CustomApolloProviderProps) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
);

const mapStateToProps = () => ({
  client: clientSingleton.get(),
});

export default connect(mapStateToProps)(CustomApolloProvider);

export { CustomApolloProvider as CustomApolloProviderForTest, mapStateToProps };
